/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Robinhood24({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="24"
      role="img"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.857 1.87c-1.782 1.671-3.596 3.684-3.596 3.684-.055.066-.011.154.055.12 1.913-.395 3.343-.648 5.466-.88.385-.032.605.034.616.353.005.114.007.32.011.6.013 1.01.039 2.975.22 4.965.011.077.088.11.143.044 0 0 1.716-2.43 3.388-4.311a.67.67 0 0 0 .143-.341c.308-2.101-.066-3.894-.715-4.52-.715-.694-2.761-.859-5.258-.012a1.146 1.146 0 0 0-.473.297Z"
        fill={CssVars.textColor}
      />
      <path
        d="M15.79 11.99c-.066-.613-.325-3.037-.316-5.226 0-.044-.066-.055-.077-.033-.18.23-.402.497-.663.81-1.444 1.732-4.05 4.86-7.003 10.86-.033.044.022.099.066.077l.314-.127c.966-.391 3.042-1.232 5.032-1.71a.227.227 0 0 0 .153-.11 78.42 78.42 0 0 1 2.486-4.279l.005-.012c.009-.027.017-.051.017-.109 0-.016-.006-.064-.014-.14Zm-1.262-5.92c.033-.043 0-.098-.044-.087-1.386.132-3.607.583-5.367 1-.139.033-.174.075-.226.138l-.005.006-.345.429c-1.102 1.37-1.87 2.324-3.219 4.322a.456.456 0 0 0-.077.297c.154 1.078.451 2.915.693 3.784a.143.143 0 0 1 .002.065.183.183 0 0 0-.002.023c-.44 1.265-1.023 3.123-1.936 6.841-.01.055.022.11.077.11h.462c.044 0 .077-.01.088-.044.011-.022.011-.033.011-.033 2.827-7.666 6.468-12.89 9.888-16.85ZM6.631 21.084l.506-1.21a.214.214 0 0 1 .11-.11c1.319-.572 2.234-.89 3.498-1.33l.066-.022c.055-.022.099.033.077.088l-.352.703c-.044.1-.1.143-.21.198-1.803.847-2.793 1.32-3.618 1.76-.044.022-.099-.022-.077-.077Z"
        fill={CssVars.textColor}
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
